var _defs, _path, _path2, _path3, _circle, _polyline, _polygon, _line, _line2, _line3, _polyline2, _polygon2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.34px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.74,452.73l29.46-26.51-3.37-4.21,38.3-32.83-13.47-45.03,1.68-10.1-17.68-5.89,15.15-55.55,25.67,6.31v5.89l9.68-1.26,3.79-10.94,12.44,4.63v10.94s15.76,6.73,12.81,21.46c-2.95,14.73-10.94,48.4-10.94,48.4l25.67,4.63s14.31,.84,16.83,10.52c2.53,9.68,15.15,60.61,15.15,60.61l-5.05,1.68,3.37,11.78s1.68,14.31,10.52,14.73c8.84,.42,12.21-1.68,16.41,0s5.47,6.31,5.47,6.31l-42.93,14.73-10.94-41.25-5.05,1.26-13.89-53.87-26.51-1.26v14.73l-46.72,42.09-4.21-3.37-16.83,14.73s-2.53,3.79-.84,8.42,6.31,5.47,7.58,9.68,.42,8.84,.42,8.84h-12.21l-22.73-28.2,2.95-2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.55,297.85c-3.99,5.22,0,13.05,0,13.05l47.56,45.87,55.98-17.68s10.52-5.05,7.58-11.78-10.1-9.68-12.21-9.68-46.72,15.57-46.72,15.57l-40.4-37.88s-6.31-4.63-11.78,2.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.31,295.56c-2.56,6.06,3.27,12.63,3.27,12.63l57.54,32.49,49.76-31.14s8.92-7.53,4.38-13.31c-4.54-5.78-12.2-6.84-14.24-6.31s-41.32,26.78-41.32,26.78l-48.61-26.54s-7.27-2.9-10.78,5.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.7,
    cy: 249.87,
    r: 29.88
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "346.78 217.88 209.58 249.87 346.78 279.75"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "233.18 282.36 257.72 283.87 256.58 311.05 281.58 310.08 280.29 338.08 333.26 314.05 330.09 295.84 304.73 290.34 307.94 263.89 288.27 257.61 233.18 282.36"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 286.18,
    y1: 307.95,
    x2: 321.53,
    y2: 299.95
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 263.87,
    y1: 303.95,
    x2: 299.23,
    y2: 291.53
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 263.87,
    y1: 282.7,
    x2: 303.86,
    y2: 266.7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "0 483.03 29.64 370.92 59.16 483.03 342.12 483.03 364.44 390.36 381.72 483.03 415.56 289.67 460.92 483.03 482.52 447.24 512 483.03 512 512 0 512"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 37.56 36.48 173.64 63.48 38.64 308.44 38.64 321.6 99.12 334.62 36.48 414.48 36.48 463.08 274.7 482.52 37.56 512 37.56 512 0 0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.58,154.35l-.34-4.38c-1.01-9.1,2.02-19.04,10.45-29.16,7.58-8.93,11.8-15.5,11.8-23.09,0-8.6-5.39-14.33-16.01-14.49-6.07,0-12.81,2.02-17.02,5.22l-4.04-10.62c5.56-4.04,15.17-6.74,24.1-6.74,19.38,0,28.15,11.97,28.15,24.77,0,11.46-6.4,19.72-14.49,29.32-7.42,8.76-10.11,16.18-9.61,24.77l.17,4.38h-13.15Zm-3.71,23.59c0-6.24,4.21-10.62,10.11-10.62s9.94,4.38,9.94,10.62c0,5.9-3.88,10.45-10.11,10.45-5.9,0-9.94-4.55-9.94-10.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9b26c58a33f92ea4e8498af2825c9a1.svg";
export { ForwardRef as ReactComponent };